import React from 'react'

const api = {
    deposit_history : '/api/user/credential/all-deposit/',
    withdraw_history: '/api/user/credential/all-withdraw/',
    work_history: '/api/user/credential/all-work/',
    transection_history: '/api/user/credential/all-transection/',
    per_total_transection_history: '/api/user/credential/all-transection-per-total/',
    fetech_club: '/api/user/log/assoc-on',
    account_create: '/api/user/log/signup',
    account_in: '/api/user/log/signin',
    account_on: '/api/user/log/my-account/1',
    password_update: '/api/user/log/change-password',
    club_update: '/api/user/log/change-club',
    account_update: '/api/user/log/update-account',
    profileImg: '/img/pro/',
    img_upload_url: '/api/user/log/image',
    work_c_live: '/api/user/work/cricket-live',
    work_f_live: '/api/user/work/football-live',
    work_t_live: '/api/user/work/tennis-live',
    work_v_live: '/api/user/work/volleyball-live',
    work_c_upcoming: '/api/user/work/cricket-upcoming',
    work_f_upcoming: '/api/user/work/football-upcoming',
    work_t_upcoming: '/api/user/work/tennis-upcoming',
    work_v_upcoming: '/api/user/work/volleyball-upcoming',
    work_single_page: '/api/user/work/single-work-fetch',
    work_option_page: '/api/user/work/work-sub_title-fetch',
    dep_method: '/api/user/work-action/method-list',
    dep_number: '/api/user/work-action/number-list/',
    dep_action: '/api/user/work-action/dep-action',
    work_regular: '/api/user/work-to/work-method-action',
    work_per: '/api/user/work-to-per/work-method-action',
    work_total: '/api/user/work-to-total/work-method-action',
    depo_img_upload_url: '/api/user/log/depo-image',
    with_method: '/api/user/work-action/w-method-list',
    with_action: '/api/user/work-action/with-action',
    notice: '/api/user/log/notice-list',
    holder_request: '/api/user/credential/holder-request-action',
    send_coin_usertouser: '/api/user/work-action/user-to-user-send-coin',
    send_coin_history: '/api/user/credential/all-send-coin/',
    get_to_phone_list: '/api/user/work-action/to-phone-list',
    send_coin_userto_club: '/api/user/work-action/user-to-mholder-send-coin',
    new_sixdigitpin: '/api/user/log/new-sixdigitpin',
    update_sixdigitpin: '/api/user/log/update-sixdigitpin',
}

export default api;